import {
    madnes_get_scale_x,
    madnes_get_scale_y,
    madnes_get_visible,
    madnes_set_visible
} from "../framework/src/engine/madnes/madnes_object";
import {madnes_tween_to} from "../framework/src/engine/madnes/madnes_tween";
import {madnes_anim_scale} from "./rof_anims";

/**
 * @constructor
 * @param {string} name
 * @param {number} xScale
 * @param {number} yScale
 * @param {number} duration
 * @param {number=} delay
 * @returns {AnimScale}
 */
export function AnimScale(name, xScale, yScale, duration, delay) {
    this.name = name;
    this.xScale = xScale;
    this.yScale = yScale;
    this.duration = duration;
    this.delay = delay;
};

/**
 * @returns {Promise}
 */
AnimScale.prototype.run = function() {
    var _self = this;
    return new Promise(function(res) {
        madnes_anim_scale(_self.name, _self.xScale, _self.yScale, _self.duration, _self.delay, res);
    });
};

/**
 * @constructor
 * @param {string} name
 * @param {number} xScale
 * @param {number} yScale
 * @param {number} duration
 * @param {number} delay
 * @returns {AnimPulse}
 */
export function AnimPulse(name, xScale, yScale, duration, delay) {
    this._name = name;
    this._xScale = xScale;
    this._yScale = yScale;
    this._duration = duration;
    this._delay = delay;

    this._origXScale = madnes_get_scale_x(this._name);
    this._origYScale = madnes_get_scale_y(this._name);
};

/**
 *
 * @returns {Promise}
 */
AnimPulse.prototype.run = function() {

    var scaleIn = new AnimScale(this._name, this._xScale, this._yScale, this._duration / 2, this._delay);
    var scaleOut = new AnimScale(this._name, this._origXScale, this._origYScale, this._duration / 2, 0);

    return scaleIn.run().then(function() {
        return scaleOut.run();
    });
};

/**
 * @constructor
 * @param {Array<string>|string} names
 * @param {number} count
 * @param {number} duration
 * @returns {AnimBlink}
 */
export function AnimBlink(names, count, duration) {

    if(typeof names == 'object') {
        this.names = names;

    } else {
        this.names = [names];
    }

    this.count = count;
    this.duration = Math.floor(duration / count / 2);

    this.origVisibility = madnes_get_visible(this.names[0]);
    this.state = 0;

    /** @type {Function} */
    this.resolver;
    this.timeoutFunc = null;
    this.stopped = false;
};

AnimBlink.prototype.setVisible = function(objects, visible) {
    for (var i = 0, len = objects.length; i < len; i++) {
        madnes_set_visible(objects[i], visible);
    }
};

AnimBlink.prototype._step = function() {
    var _self = this;

    if(this.stopped) {
        return false;
    }

    if(this.count <= 0) {
        this.setVisible(this.names, this.origVisibility);
        this.resolver && this.resolver();
        return false;
    }

    var isVisible = madnes_get_visible(this.names[0]);

    this.timeoutFunc = setTimeout(function() {
        if(_self.origVisibility != isVisible) {
            _self.count--;
        }

        _self.setVisible(_self.names, !isVisible);
        _self._step();

    }, this.duration);
};

/**
 * @returns {Promise}
 */
AnimBlink.prototype.run = function() {
    var _this = this;
    this.stopped = false;

    return new Promise(function(resolve) {
        _this.resolver = resolve;
        _this._step();
    });
};

AnimBlink.prototype.stop = function() {
    this.resolver = null;
    this.stopped = true;

    if(this.timeoutFunc) {
        clearTimeout(this.timeoutFunc);
    }
};

/**
 * @constructor
 * @param {string} name
 * @returns {AnimTween}
 */
export function AnimTween(name) {
    this._name = name;

    /** @type {Phaser.Tween} */
    this._tween;
};

AnimTween.prototype.to = function(settings, duration, delay, count, yoyo) {

    var props = {
        'duration': duration,
        'delay': delay,
        'count': count,
        'yoyo': yoyo
    };

    this._tween = madnes_tween_to(this._name, settings, props);
};


AnimTween.prototype.stop = function() {
    this._tween && this._tween.stop();
};